export const CLEAR_WAITLIST = 'lumahealth/WaitlistPage/CLEAR_WAITLIST';

export const LOAD_APPOINTMENT_TYPES = 'lumahealth/WaitlistPage/LOAD_APPOINTMENT_TYPES';
export const LOAD_APPOINTMENT_TYPES_SUCCESS = 'lumahealth/WaitlistPage/LOAD_APPOINTMENT_TYPES_SUCCESS';
export const LOAD_APPOINTMENT_TYPES_ERROR = 'lumahealth/WaitlistPage/LOAD_APPOINTMENT_TYPES_ERROR';

export const LOAD_FACILITIES = 'lumahealth/WaitlistPage/LOAD_FACILITIES';
export const LOAD_FACILITIES_SUCCESS = 'lumahealth/WaitlistPage/LOAD_FACILITIES_SUCCESS';
export const LOAD_FACILITIES_ERROR = 'lumahealth/WaitlistPage/LOAD_FACILITIES_ERROR';

export const LOAD_FUTURE_APPOINTMENTS = 'lumahealth/WaitlistPage/LOAD_FUTURE_APPOINTMENTS';
export const LOAD_FUTURE_APPOINTMENTS_SUCCESS = 'lumahealth/WaitlistPage/LOAD_FUTURE_APPOINTMENTS_SUCCESS';
export const LOAD_FUTURE_APPOINTMENTS_ERROR = 'lumahealth/WaitlistPage/LOAD_FUTURE_APPOINTMENTS_ERROR';

export const LOAD_PATIENTS = 'lumahealth/WaitlistPage/LOAD_PATIENTS';
export const LOAD_PATIENTS_SUCCESS = 'lumahealth/WaitlistPage/LOAD_PATIENTS_SUCCESS';
export const LOAD_PATIENTS_ERROR = 'lumahealth/WaitlistPage/LOAD_PATIENTS_ERROR';

export const LOAD_PROVIDERS = 'lumahealth/WaitlistPage/LOAD_PROVIDERS';
export const LOAD_PROVIDERS_SUCCESS = 'lumahealth/WaitlistPage/LOAD_PROVIDERS_SUCCESS';
export const LOAD_PROVIDERS_ERROR = 'lumahealth/WaitlistPage/LOAD_PROVIDERS_ERROR';

export const LOAD_WAITLIST = 'lumahealth/WaitlistPage/LOAD_WAITLIST';
export const LOAD_WAITLIST_SUCCESS = 'lumahealth/WaitlistPage/LOAD_WAITLIST_SUCCESS';
export const LOAD_WAITLIST_ERROR = 'lumahealth/WaitlistPage/LOAD_WAITLIST_ERROR';

export const DELETE_WAITLIST = 'lumahealth/WaitlistPage/DELETE_WAITLIST';
export const DELETE_WAITLIST_SUCCESS = 'lumahealth/WaitlistPage/DELETE_WAITLIST_SUCCESS';
export const DELETE_WAITLIST_ERROR = 'lumahealth/WaitlistPage/DELETE_WAITLIST_ERROR';

export const LS_WAITLIST_SHOW_ADDITIONAL_FIELDS = 'lh:waitlist_show_additional_fields';

export const PREFERRED_DAYS_OPTIONS = [
  {
    id: '1',
    label: 'Monday',
  },
  {
    id: '2',
    label: 'Tuesday',
  },
  {
    id: '3',
    label: 'Wednesday',
  },
  {
    id: '4',
    label: 'Thursday',
  },
  {
    id: '5',
    label: 'Friday',
  },
  {
    id: '6',
    label: 'Saturday',
  },
  {
    id: '0',
    label: 'Sunday',
  },
];

export const PREFERRED_TIME_OPTIONS = [
  { id: 'anytime', label: 'No preference' },
  { id: 'before-lunch', label: 'Before lunchtime' },
  { id: 'after-lunch', label: 'After lunchtime' },
];

export const UPDATE_OFFER_STATUS = 'lumahealth/WaitlistPage/UPDATE_OFFER_STATUS';
export const UPDATE_OFFER_STATUS_SUCCESS = 'lumahealth/WaitlistPage/UPDATE_OFFER_STATUS_SUCCESS';
export const UPDATE_OFFER_STATUS_ERROR = 'lumahealth/WaitlistPage/UPDATE_OFFER_STATUS_ERROR';

export const SAVE_WAITLIST = 'lumahealth/WaitlistPage/SAVE_WAITLIST';
export const SAVE_WAITLIST_SUCCESS = 'lumahealth/WaitlistPage/SAVE_WAITLIST_SUCCESS';
export const SAVE_WAITLIST_ERROR = 'lumahealth/WaitlistPage/SAVE_WAITLIST_ERROR';

export const WAITLIST_FORM = 'WaitlistPageForm';
